import PropTypes from 'prop-types';
import { Button, Icon } from '@evertrue/et-components';

/**
 * Breadcrumb navigation for cadence detail pages.
 * Renders a back chevron, clickable link chain, and the current page name.
 */
const CadenceDetailBreadcrumb = ({ crumbs, currentName, className = '' }) => {
  const handleBack = crumbs.length > 0 ? crumbs[0].onClick : undefined;

  return (
    <div className={`cadence-detail-breadcrumb ${className}`}>
      {handleBack && (
        <Button type="simple" onClick={handleBack} className="cadence-detail-breadcrumb--back-btn">
          <Icon icon="chevron-left" />
        </Button>
      )}
      <span className="cadence-detail-breadcrumb--text">
        {crumbs.map((crumb) => (
          <span key={crumb.label}>
            <button type="button" className="cadence-detail-breadcrumb--link" onClick={crumb.onClick}>
              {crumb.label}
            </button>
            {' / '}
          </span>
        ))}
        <span className="cadence-detail-breadcrumb--current">{currentName}</span>
      </span>
    </div>
  );
};

CadenceDetailBreadcrumb.propTypes = {
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ).isRequired,
  currentName: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default CadenceDetailBreadcrumb;
